import { privateApi } from 'services';
import { JobsDashboardCampaigns } from './types';

const fetchJobsDashboardCampaigns = (businessAccountId: string): Promise<JobsDashboardCampaigns> =>
    privateApi.get<JobsDashboardCampaigns>(`business-accounts/${businessAccountId}/jobs/dashboard-campaigns`);

export const JobsDashboardCampaignGateway = {
    fetchJobsDashboardCampaigns,
};
